<template>

  <div class="row justify-content-center">

  <div class="col-12 col-md-12 col-lg-12" v-for="item in activities">

    <div v-for="obj, key in contracts.contracts" v-if="obj.offName === item.name && obj.status === true && item.activities.length > 1" >

    <h5 class="info-text">{{item.name}} activities</h5>
    <fg-input>
      <el-select v-if="contracts.language === 'fr'" v-model="contractActivities[item.name]" multiple filterable placeholder="Select"> <!-- obj.activities.name -->
        <el-option
                v-for="sub in item.activities"
                :key="sub.name"
                :label="sub.name_fr"
                :value="sub.name">
        </el-option>
      </el-select>
      <el-select v-if="contracts.language === 'en'" v-model="contractActivities[item.name]" multiple filterable placeholder="Select"> <!-- obj.activities.name -->
        <el-option
            v-for="sub in item.activities"
            :key="sub.name"
            :label="sub.name"
            :value="sub.name">
        </el-option>
      </el-select>
      <el-select v-if="contracts.language === 'nl'" v-model="contractActivities[item.name]" multiple filterable placeholder="Select"> <!-- obj.activities.name -->
        <el-option
            v-for="sub in item.activities"
            :key="sub.name"
            :label="sub.name_nl"
            :value="sub.name">
        </el-option>
      </el-select>
    </fg-input>
  </div>

    <div v-for="obj, key in contracts.contracts" v-if="obj.offName === item.name && obj.status === true && item.activities.length < 2" >

      <h5 class="info-text">{{item.name}} activities</h5>
      <div style="text-align:center;color: gray;">There is no activities to specify for this supplier</div>
    </div>
  </div>
  <br><br>

<div>

</div>

  </div>

</template>
<script>
  import {Select, Option} from 'element-ui'
  import vueEsign from 'vue-esign'
  export default {
    props: ['contracts', 'language'],
    components: {
      [Select.name]: Select,
      [Option.name]: Option
    },
    data() {
      return {
        links: [],
        contractActivities: {
          EcoSodexo: [],
          EcoEdenred: [],
          GiftEdenred: [],
          MealEdenred: [],
          MealMonizze: [],
          EcoMonizze: [],
          GiftMonizze: [],
          MealSodexo: [],
          MealSodexoPluxee: [],
          EcoSodexoPluxee: []
        },
        activities: [],
        model : {},
        value: [],
        modelValidations: {
          street: {
            required: true,
            min: 5
          }
        }
      }
    },
    mounted() {
      this.getActivities()

    },
    methods: {
      setEmptyActivities() {

        this.activities.forEach( el => {
          console.log(el.name + ' with '+ el.activities.length + ' activities')
          //console.log(this.contracts)
          Object.keys(this.contracts.contracts).forEach(key => {
            if(el.name === this.contracts.contracts[key].offName && el.activities.length < 2 && this.contracts.contracts[key].status === true) {
              console.log("ToSet")
              this.contractActivities[el.name] = [el.activities[0]]
            }

          })

        })
      },
      getActivities() {
        this.$http({
          method: 'get',
          url: this.$apiUrl + '/contract/getActivities',
          headers: {'Authorization': 'Bearer ' + localStorage.token}
        }).then(response => (
          //console.log(response.data),
          this.activities = response.data
        )).catch(err => {
          this.$notify({
            message: 'Impossible to retrieve data',
            type: 'danger',
            horizontalAlign: 'center',
            verticalAlign: 'top'
          })
        })
      },
      async genContract(ref) {
        ref.temporary = true,
        await this.$http({
          method: 'post',
          url: this.$apiUrl + '/contract/contract',
          headers: {'Authorization': 'Bearer ' + localStorage.token},
          data: ref
        }).then(response => (
                this.links = response.data,
                        console.log(response.data)
        )).catch(err => {
          this.$notify({
            message: 'Impossible to generate this contract',
            type: 'danger',
            horizontalAlign: 'center',
            verticalAlign: 'top'
          })
        })
      },
      getError(fieldName) {
        return this.errors.first(fieldName)
      },
      async validate() {
        this.setEmptyActivities(),
        this.contracts.contracts = this.contractActivities,
                this.contracts.sign = "data:image/png;base64,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",
        await this.genContract(this.contracts)
        return this.$validator.validateAll().then(res => {
          this.$emit('on-validated', res, { contracts: this.contractActivities, links: this.links })
          return res
        })
      }
    }

  }
</script>
<style>

  el-select-dropdown {
    left: auto !important
  }
  .el-select-dropdown__item {
    overflow: auto !important;
  }

</style>
